import React from "react";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import Skeleton from "react-loading-skeleton";
import withCustomStyles from "./TopBrandsPart.style";
import ImageWithLoaderPart from "./ImageWithLoaderPart";
import { GRail } from "./ui";
import { getBrandPageUrl, getImageWithBaseUrl } from "../utils/UrlUtils";

const MAX_BRANDS = 16;

// "Top brands" rail: hairline cards with a round logo and the brand name.
@inject(["allBrandsStore"])
@observer
class TopBrandsPart extends React.Component {
  render() {
    const { allBrandsStore, classes } = this.props;
    const brands = allBrandsStore.limited
      .filter(brand => brand.brand_slider_image)
      .slice(0, MAX_BRANDS);
    const loading =
      brands.length === 0 && allBrandsStore.fetchLimitedState === "fetching";

    if (!loading && brands.length === 0) {
      return null;
    }

    return (
      <GRail title="Top brands" seeAllTo="/shops" kind="brand">
        {loading
          ? Array.from({ length: 8 }, (_, i) => (
              <div key={i} className={classes.card} aria-hidden="true">
                <Skeleton circle width={88} height={88} />
                <Skeleton width={80} height={16} />
              </div>
            ))
          : brands.map(brand => (
              <Link
                key={brand.id}
                to={getBrandPageUrl(brand.slug)}
                className={classes.card}
              >
                <span className={classes.logo}>
                  <ImageWithLoaderPart
                    width="88"
                    height="88"
                    src={getImageWithBaseUrl(brand.brand_slider_image)}
                    alt=""
                    className={classes.logoImg}
                  />
                </span>
                <span className={classes.name}>{brand.name}</span>
              </Link>
            ))}
      </GRail>
    );
  }
}

export default withCustomStyles(TopBrandsPart);
